import * as React from "react";
const SvgZoomIn20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3 8.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM8.5 1a7.5 7.5 0 1 0 4.55 13.463L17 18.414 18.414 17l-3.95-3.95A7.5 7.5 0 0 0 8.5 1Zm1 11V9.5H12v-2H9.5V5h-2v2.5H5v2h2.5V12h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgZoomIn20Px;
